import { useInvalidateUseGetCampaign } from '@urbanx/agx.campaigns.client';
import { useQueryClient } from '@tanstack/react-query';
import { createCampaignQueryKey } from './useSelectedCampaign';

export const useCampaignStaleMarker = () => {
  const queryClient = useQueryClient();
  const invalidateGeneratedCampaign = useInvalidateUseGetCampaign();

  const markCampaignsAsStale = async (campaignId: string) => {
    const campaignQueryKey = createCampaignQueryKey(campaignId);

    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: campaignQueryKey,
      }),
      invalidateGeneratedCampaign(campaignId),
    ]);
  };

  return markCampaignsAsStale;
};
